import { Box, Typography } from "@mui/material";
import React from "react";
import { SvgReport } from "source/shared/icons/Report.svg";

interface DashboardPanelNoReportProps {
  title: string;
}

export const DashboardPanelNoReport = ({
    title,
}: DashboardPanelNoReportProps) => {
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "action.hover",
                borderRadius: ".25rem",
                padding: "2rem",
            }}
        >
            <SvgReport />
            <Typography
                variant="caption"
                sx={{ color: "text.secondary", marginTop: ".75rem" }}
            >
                {title}
            </Typography>
        </Box>
    );
};
